import React, { useState } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import { numericInputPattern, preventMaxInput } from 'utils/validations'
import formValidation from '../../utils/formValidation'
import { BiPlusMedical } from 'react-icons/bi'
import { TiDelete } from 'react-icons/ti'
import ErrorMessage from 'components/ErrorMessage'
import helpers from 'utils/helpers'

const SubscriptionEdit = ({ allSubscription, currentItem, handleEdit }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const [isLoading, setIsLoading] = useState(false)
  const {
    register,
    handleSubmit,
    watch,
    resetField,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      noOfEmployee: currentItem?.noOfEmployee,
      noOfHR: currentItem?.noOfHR,
      noOfAccountant: currentItem?.noOfAccountant,
      name: currentItem.name?.trim(),
      amount: currentItem?.amount,
      duration: currentItem?.duration
    }
  })
  const [splFeatureData, setSplFeatureData] = useState(currentItem?.description)
  const [descriptionError, setDescriptionError] = useState(false)

  const checkFields = feature => {
    let isValid = true
    if (feature.length === 0) {
      setDescriptionError(true)
      isValid = false
    } else {
      setDescriptionError(false)
    }
    if (watch('description')?.length < 3 && feature.length === 0) {
      isValid = false
    }
    return isValid
  }

  const onSubmit = async data => {
    try {
      let feature = [...splFeatureData]
      if (watch('description')?.length >= 3) feature.push(watch('description'))
      const isValid = checkFields(feature)
      if (!isValid) return
      setIsLoading(true)
      const payload = {
        name: data.name,
        amount: data?.amount,
        duration: data?.duration,
        description: feature,
        noOfEmployee: data?.noOfEmployee,
        noOfHR: data?.noOfHR,
        noOfAccountant: data?.noOfAccountant
      }
      var path = apiPath.subscriptionUpdate + '/' + currentItem._id
      const result = await apiPut(path, payload)
      if (result.data.success) {
        allSubscription()
        handleEdit(false)
        notification.success(result?.data.message)
      } else {
        notification.error(result?.data.message)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error)
      notification.error(error.message)
    }
    setIsLoading(false)
  }

  const renderFooter = () => (
    <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
      <button
        className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
        type='button'
        onClick={() => handleEdit(false)}
      >
        {t('O_BACK')}
      </button>
      {isLoading ? (
        <div className='spinner-container bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'>
          <div className='loading-spinner'></div>
        </div>
      ) : (
        <button
          className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
          type='submit'
          onClick={handleSubmit(onSubmit, () => {
            const isValid = checkFields(splFeatureData)

            if (!isValid) return
          })}
        >
          {t('O_SAVE')}
        </button>
      )}
    </div>
  )

  const preventMaxHundredDays = e => {
    if (e.target.value > 100) {
      e.target.value = e.target.value.slice(0, 1000)
    }
  }

  const specialFeatureData = watch('description')

  const preventMax = e => {
    if (e.target.value.length > 10) {
      e.target.value = e.target.value.slice(0, 10)
    }
  }

  const AddInputValue = () => {
    if (specialFeatureData !== undefined && specialFeatureData.length >= 3) {
      setSplFeatureData([...splFeatureData, specialFeatureData])
      resetField('description')
    }
  }
  const handleDeleteData = id => {
    const updatedDataArray = splFeatureData.filter((data, i) => i !== id)
    setSplFeatureData(updatedDataArray)
  }
  return (
    <>
      <div className='overflow-x-hidden overflow-y-auto fixed inset-0 z-50 justify-center items-center flex outline-none focus:outline-none'>
        <div className='w-auto my-6 mx-auto max-w-3xl relative '>
          <div className='md:py-4 sm:py-8 px-7 sm:px-2 '>
            <div className='relative flex flex-col w-full bg-white outline-none border-0 rounded-lg shadow-lg focus:outline-none min-w-[762px]'>
              <div className='justify-between p-5 border-b border-solid flex items-center border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {t('EDIT_SUBSCRIPTION')}
                </h3>
                <button
                  onClick={() => handleEdit(false)}
                  className=' justify-center  text-black border-2 ml-auto flex items-center rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  title='Close'
                >
                  <span className='text-4xl  text-[#B8BBBF]' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative flex-auto p-6 '>
                <div className='sm:grid-cols-2 grid '>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='w-full group relative z-0  '>
                      <OInputField
                        type='text'
                        autoFocus
                        maxLength={50}
                        onInput={e => preventMaxInput(e, 50)}
                        register={register(
                          'name',
                          formValidation['subscriptionName']
                        )}
                        errors={errors}
                        wrapperClassName='z-0 w-full group relative '
                        name='name'
                        inputLabel={
                          <>
                            {t('SUBSCRIPTION_NAME')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                      />
                    </div>
                  </div>
                  <div className='sm:px-2 sm:py-8 md:py-4 px-7'>
                    <div className='relative w-full group z-0 '>
                      <OInputField
                        name='amount'
                        id='amount'
                        onInput={e => preventMax(e)}
                        maxLength={10}
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        inputLabel={
                          <>
                            {t('AMOUNT')} ($)
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        onKeyDown={event => numericInputPattern(event)}
                        register={register('amount', formValidation['amount'])}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='z-0 w-full group relative '>
                      <OInputField
                        register={register(
                          'duration',
                          formValidation['duration']
                        )}
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        inputLabel={
                          <>
                            {t('DURATION')} (In days)
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        onKeyDown={event => numericInputPattern(event)}
                        id='duration'
                        name='duration'
                        onInput={e => preventMaxHundredDays(e)}
                        maxLength={4}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        inputLabel={
                          <>
                            {t('NUMBER_OF_EMPLOYEE')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        onInput={e => preventMax(e)}
                        maxLength={10}
                        onKeyDown={event => numericInputPattern(event)}
                        name='noOfEmployee'
                        id='noOfEmployee'
                        register={register(
                          'noOfEmployee',
                          formValidation['noOfEmployee']
                        )}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        inputLabel={
                          <>
                            {t('NUMBER_OF_HR')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        name='noOfHR'
                        id='noOfHR'
                        onInput={e => preventMax(e)}
                        maxLength={10}
                        onKeyDown={event => numericInputPattern(event)}
                        register={register('noOfHR', formValidation['noOfHR'])}
                      />
                    </div>
                  </div>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        wrapperClassName='relative z-0 w-full group'
                        errors={errors}
                        inputLabel={
                          <>
                            {t('NUMBER_OF_ACCOUNTANT')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        name='noOfAccountant'
                        maxLength={10}
                        onKeyDown={event => numericInputPattern(event)}
                        id='noOfAccountant'
                        onInput={e => preventMax(e)}
                        register={register(
                          'noOfAccountant',
                          formValidation['noOfAccountant']
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className='grid'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <OInputField
                        wrapperClassName='relative z-0 w-full group'
                        inputLabel={
                          <>
                            {t('DESCRIPTION')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        onInput={e => preventMaxInput(e, 300)}
                        maxLength={300}
                        greyClass
                        type='text'
                        name='description'
                        register={register('description')}
                      />
                      {watch('description') == '' && descriptionError && (
                        <ErrorMessage message='Please enter description.' />
                      )}
                      {watch('description') != '' && (
                        <ErrorMessage
                          message={helpers?.ternaryCondition(
                            watch('description')?.length < 3,
                            'Minimum length must be 3',
                            ''
                          )}
                        />
                      )}
                      <span className='right-[20px] password_view absolute top-[18px] '>
                        <BiPlusMedical onClick={AddInputValue} />
                      </span>
                      <div className=' overflow-auto max-h-[200px]'>
                        {splFeatureData &&
                          splFeatureData.map((item, i) => {
                            return (
                              <ul key={i}>
                                <li className='px-2.5 py-0.5 text-gray-800 text-xs font-medium mr-2 flex justify-between bg-gray-100 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500 mt-2'>
                                  {item}{' '}
                                  <span className='w-[32px]'>
                                    {' '}
                                    <TiDelete
                                      onClick={() => handleDeleteData(i)}
                                      className='h-5 w-10 '
                                    />
                                  </span>
                                </li>
                              </ul>
                            )
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {renderFooter()}
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed z-40 bg-black inset-0 ' />
    </>
  )
}

export default SubscriptionEdit
